/* eslint camelcase: 0 */

import { FormsHandbook as Data } from '@/typings/api/FormsHandbook'
import { Model, createMessages } from '@/helpers/Model'


export class FormsHandbookModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить справочник',
    edit: 'Редактировать справочник',
    view: (data: FormsHandbookModel) => 'Справочник «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Справочники',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data: FormsHandbookModel) => 'Удаление справочника «{name}»'
      .replace('{name}', data.name || '...'),
  });
}
